import { render } from "./QRadioGroup.vue?vue&type=template&id=0adf4608&scoped=true"
import script from "./QRadioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./QRadioGroup.vue?vue&type=script&setup=true&lang=js"

import "./QRadioGroup.vue?vue&type=style&index=0&id=0adf4608&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adf4608"],['__file',"src/components/UI/buttons/QRadioGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0adf4608"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0adf4608', __exports__)) {
    api.reload('0adf4608', __exports__)
  }
  
  module.hot.accept("./QRadioGroup.vue?vue&type=template&id=0adf4608&scoped=true", () => {
    api.rerender('0adf4608', render)
  })

}


export default __exports__